import type {
  Card,
  CardsBlock,
  Eyebrow,
  LocaleMap,
  PageHeaderBlock,
} from "./types";

export const SUPPORTED_LOCALES = ["de", "en"] as const;

export const emptyLocaleMap = (): LocaleMap =>
  Object.fromEntries(SUPPORTED_LOCALES.map((l) => [l, ""])) as LocaleMap;

export const defaultEyebrow = (): Eyebrow => ({
  text: emptyLocaleMap(),
  color: "primary",
  isBadge: false,
  icon: null,
});

export const defaultCard = (): Card => ({
  align: "left",
  orientation: "vertical",
  icon: "",
  iconBackground: "primary",
  iconColor: "primary",
  title: emptyLocaleMap(),
  description: emptyLocaleMap(),
});

export const defaultCardsBlock = (id: string): CardsBlock => ({
  id,
  type: "cards",
  hasEyebrow: false,
  eyebrow: defaultEyebrow(),
  title: emptyLocaleMap(),
  description: emptyLocaleMap(),
  gridOrientation: "vertical",
  hasGlowEffect: false,
  cards: [],
});

export const defaultPageHeaderBlock = (id: string): PageHeaderBlock => ({
  id,
  type: "pageHeader",
  hasEyebrow: false,
  eyebrow: defaultEyebrow(),
  title: emptyLocaleMap(),
  description: emptyLocaleMap(),
  layout: "vertical",
  hasImage: false,
  imagePosition: "right",
  image: null,
  hasBackground: false,
  backgroundType: "color",
  backgroundColor: null,
  backgroundImage: null,
});
